module.exports = __webpack_public_path__ + "img/conectada_03.f1b370a0.svg";